// extracted by mini-css-extract-plugin
module.exports = {"cursor":"IconEnquiry_cursor__2r4bx","root":"IconEnquiry_root__2cCGS","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__11lp0"};